import { useNavigate } from "react-router-dom";

const Home = () => {
  const navigate = useNavigate();

  return (
    <div>
      <section class="home" id="home">
        <div class="content1">
          <h1>Coffee, Please.</h1>
          <p>Create Forms, Show Your Form history</p>
          <button
            onClick={() => navigate("/login")}
            type="button"
            class="btn btn-dark">
            SignIn Now
          </button>
        </div>
      </section>
    </div>
  );
};

export default Home;
